import React from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import SharePointConfig from './components/SharePoint/SharePointConfig';
import AdminSharePointConfigRoute from './components/SharePoint/AdminSharePointConfigRoute';
import UserManagement from './components/UserManagement/UserManagement';
import SharePointReport from './components/SharePoint/SharePointReport';
import ExternalSharingReport from './components/Reports/ExternalSharingReport';
import SecurityAuditReportDW from './components/SecurityAuditReportDW';
import SecurityLookup from './components/Security/SecurityLookup';
import FileManagement from './components/FileManagement';
import FileUsageReport from './components/FileUsageReport';
import ETLMonitoring from './components/ETLMonitoring';
import ETLStats from './components/SharePoint/ETLStats';
import StorageGrowthReport from './components/Reports/StorageGrowthReport';
import Home from './components/Home';
import Login from './components/Auth/Login';
import ChangePassword from './components/Auth/ChangePassword';
import RegistrationInvitesOnly from './components/Auth/RegistrationInvitesOnly';
import Dashboard from './components/Dashboard';
import PaymentConfirmation from './components/Payment/PaymentConfirmation';
import SharePointTokenManager from './components/SharePoint/SharePointTokenManager';
import EtlOperationsDashboard from './components/Admin/EtlOperationsDashboard';
import AuthCallback from './components/AuthCallback';
import ProtectedRoute from './components/ProtectedRoute';
import AdminRoute from './components/AdminRoute';

function UserScopeReportRedirect() {
  const { search } = useLocation();
  return <Navigate to={{ pathname: '/permission-scope-report', search }} replace />;
}

const AppRoutes = () => {
  return (
        <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/dashboard" element={<ProtectedRoute component={Dashboard} />} />
            <Route path="/callback" element={<Navigate to="/dashboard" replace />} />
            <Route path="/sharepoint-config" element={<ProtectedRoute component={SharePointConfig} />} />
            <Route path="/admin/sharepoint-config/:email" element={<AdminRoute component={AdminSharePointConfigRoute} roles={['System Admin']} />} />
            <Route path="/user-management" element={<AdminRoute component={UserManagement} roles={['System Admin']} />} />
            <Route path="/admin/etl-operations" element={<AdminRoute component={EtlOperationsDashboard} roles={['System Admin']} />} />
            <Route path="/security-report" element={<ProtectedRoute component={SharePointReport} />} />
            <Route path="/external-sharing-report" element={<ProtectedRoute component={Dashboard} />} />
            <Route path="/security-audit-report-dw" element={<ProtectedRoute component={Dashboard} />} />
            <Route path="/security-lookup" element={<ProtectedRoute component={SecurityLookup} />} />
            <Route path="/file-management" element={<ProtectedRoute component={Dashboard} />} />
            <Route path="/file-usage-report" element={<ProtectedRoute component={Dashboard} />} />
            <Route path="/permission-scope-report" element={<ProtectedRoute component={Dashboard} />} />
            <Route path="/user-scope-report" element={<UserScopeReportRedirect />} />
            <Route path="/etl-monitor" element={<ProtectedRoute component={Dashboard} />} />
            <Route path="/etl-stats" element={<ProtectedRoute component={Dashboard} />} />
            <Route path="/storage-growth" element={<ProtectedRoute component={Dashboard} />} />
            <Route path="/sharepoint-tokens" element={<ProtectedRoute component={SharePointTokenManager} />} />
            <Route path="/auth/callback" element={<AuthCallback />} />
            <Route path="/login" element={<Login />} />
            <Route path="/change-password" element={<ProtectedRoute component={ChangePassword} />} />
            <Route path="/register" element={<RegistrationInvitesOnly />} />
            <Route path="/payment-confirmation" element={<PaymentConfirmation />} />
            <Route path="*" element={<div style={{padding: '20px', backgroundColor: 'red', color: 'white'}}>CATCH-ALL ROUTE - PATH: {window.location.pathname}</div>} />
        </Routes>
  );
};

export default AppRoutes; 